const visitTypes = {
  UnSet: 0,
  AusenciaJustificadaDelEstudiante: 5,
  CambiosProgramacionEscolar: 19,
};

export default visitTypes;
